interface LoadingStateProps {
  message: string;
}

export const LoadingState = ({ message }: LoadingStateProps) => {
  return (
    <div className='flex items-center justify-center min-h-[calc(100vh-12rem)]'>
      <div className='text-center'>
        <div className='mb-6'>
          <div className='mx-auto h-16 w-16 animate-spin rounded-full border-4 border-gray-700 border-t-blue-500' />
        </div>
        <p className='text-xl font-semibold text-white'>{message}</p>
      </div>
    </div>
  );
};
